import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import Editor from "../../account/photo/avatarEditor";

const useStyles = makeStyles({
  container: {}
});

const UploadPhoto = props => {
  const { savePhoto } = props;
  const classes = useStyles();
  const language = useSelector(state => state.language);

  return (
    <div className={classes.container}>
      <Editor
        savePhoto={savePhoto}
        language={language}
        isNotLoggedIn={true}
        close={() => null}
      />
    </div>
  );
};

export default UploadPhoto;
